import React, { useMemo, useState } from 'react';

import { Link, NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';

import styles from './Sidebar.module.sass';
import Icon from '../Icon';
import Theme from '../Theme';
import Dropdown from './Dropdown';
import Image from '../Image';
import { paths } from 'router/paths';
import { useAppSelector } from 'store';
import { accountSelectors } from 'store/account';
import { RoleType } from '@core';
import { validateUserPermissions } from 'core/utils/validateUserPermissions';

const navigation = [
  {
    title: 'მთავარი',
    icon: 'home',
    url: paths.DASHBOARD_PATH,
    role: RoleType.MODERATOR,
  },
  {
    title: 'მომხმარებლები',
    icon: 'profile-circle',
    url: paths.USER_LIST_PATH,
    role: RoleType.MODERATOR,
  },
  {
    title: 'ივენთები',
    icon: 'diamond',
    role: RoleType.EVENT_MANAGER,
    dropdown: [
      {
        title: 'მიმდინარე',
        url: `${paths.EVENTS_LIST_PATH}?time=current`,
      },
      {
        title: 'წარსული',
        url: `${paths.EVENTS_LIST_PATH}?time=past`,
      },
    ],
  },
  {
    title: 'ბილეთები',
    icon: 'ticket',
    url: paths.TICKET_LIST_PATH,
    role: RoleType.TICKET_MANAGER,
  },
  {
    title: 'რეიტინგები',
    icon: 'promotion',
    url: paths.RANKING_LIST_PATH,
    role: RoleType.MODERATOR,
  },
  {
    title: 'შეტყობინებები',
    icon: 'notification',
    url: paths.NOTIFICATION_LIST_PATH,
    role: RoleType.EVENT_MANAGER,
  },
  {
    title: 'ბანერი',
    slug: 'income',
    icon: 'pie-chart',
    role: RoleType.MODERATOR,
    url: paths.BANNER_EDITOR_PATH,
  },
  {
    title: 'სტატიკური გვერდები',
    slug: 'income',
    icon: 'pie-chart',
    role: RoleType.MODERATOR,
    dropdown: [
      {
        title: 'წესები',
        url: '/page-editor/rules',
      },
      {
        title: 'სიმღერები',
        url: '/page-editor/songs',
      },
      {
        title: 'კონტაქტი',
        url: '/page-editor/contact',
      },
    ],
  },
  {
    title: 'თარგმანი',
    slug: 'income',
    icon: 'mouse',
    role: RoleType.MODERATOR,
    dropdown: [
      {
        title: 'ინგლისური',
        url: '/translate/en',
      },
      {
        title: 'ქართული',
        url: '/translate/ka',
      },
    ],
  },
];

interface SidebarProps {
  className?: string;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ className, onClose }) => {
  const [visible, setVisible] = useState(false);
  const user = useAppSelector(accountSelectors.userSelector);

  const filteredNavigation = useMemo(() => {
    console.log(user, 'user');
    if (!user) return [];
    return navigation.filter(nav => validateUserPermissions(user, [nav.role]));
  }, [user]);

  console.log(filteredNavigation, 'filteredNavigation');
  const { pathname } = useLocation();

  return (
    <>
      <div
        className={cn(styles.sidebar, className, {
          [styles.active]: visible,
        })}
      >
        <button className={styles.close} onClick={onClose}>
          <Icon name="close" size="24" />
        </button>
        <Link className={styles.logo} to="/" onClick={onClose}>
          <Image className={styles.pic} src="/images/logo-dark.png" srcDark="/images/logo-light.png" alt="Core" />
        </Link>
        <div className={styles.menu}>
          {filteredNavigation.map((x, index) =>
            x.url ? (
              <NavLink
                className={cn(styles.item, {
                  [styles.active]: pathname === x.url,
                })}
                to={x.url}
                key={index}
                onClick={onClose}
              >
                <Icon name={x.icon} size="24" />
                {x.title}
              </NavLink>
            ) : (
              <Dropdown
                className={styles.dropdown}
                visibleSidebar={visible}
                setValue={setVisible}
                key={index}
                item={x}
                onClose={onClose}
              />
            ),
          )}
        </div>
        <button className={styles.toggle} onClick={() => setVisible(!visible)}>
          <Icon name="arrow-right" size="24" />
          <Icon name="close" size="24" />
        </button>
        <div className={styles.foot}>
          <Theme className={styles.theme} visibleSidebar={visible} />
        </div>
      </div>
      <div className={cn(styles.overlay, { [styles.active]: visible })} onClick={() => setVisible(false)}></div>
    </>
  );
};

export default Sidebar;
